export default __webpack_public_path__ + "static/media/img--kitchen-2-dark.536d4293.jpg";